(() => {
  const rootSelector = '[data-nh-video-reviews]';

  const pauseVideo = (video) => {
    if (video && !video.paused) video.pause();
  };

  const loadVideo = (video) => {
    if (!video || video.dataset.loaded === 'true') return;
    const source = video.querySelector('source[data-src]');
    if (!source) return;
    source.src = source.dataset.src;
    video.dataset.loaded = 'true';
    video.load();
  };

  const syncCard = (video) => {
    const card = video.closest('[data-nh-video-card]');
    const toggle = card?.querySelector('[data-nh-video-toggle]');
    if (!card || !toggle) return;
    const playing = !video.paused && !video.ended;
    card.classList.toggle('is-playing', playing);
    toggle.setAttribute('aria-label', playing ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
  };

  const pauseOtherVideos = (activeVideo) => {
    document.querySelectorAll(`${rootSelector} video[data-nh-video]`).forEach((video) => {
      if (video !== activeVideo) pauseVideo(video);
    });
  };

  const toggleVideo = async (video) => {
    if (!video) return;
    if (!video.paused && !video.ended) {
      video.pause();
      return;
    }
    pauseOtherVideos(video);
    loadVideo(video);
    try {
      await video.play();
    } catch (error) {
      syncCard(video);
    }
  };

  const init = () => {
    document.querySelectorAll(`${rootSelector}:not([data-nh-video-bound])`).forEach((root) => {
      root.dataset.nhVideoBound = 'true';
      const track = root.querySelector('[data-nh-video-track]');
      const cards = Array.from(root.querySelectorAll('[data-nh-video-card]'));
      const prev = root.querySelector('[data-nh-video-prev]');
      const next = root.querySelector('[data-nh-video-next]');
      const count = root.querySelector('[data-nh-video-count]');
      const dots = Array.from(root.querySelectorAll('[data-nh-video-dot]'));
      if (!track || !cards.length) return;

      let activeIndex = 0;
      let scrollFrame = 0;

      const cardStep = () => {
        if (cards.length < 2) return cards[0].getBoundingClientRect().width;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      };

      const updateNavigation = () => {
        scrollFrame = 0;
        activeIndex = cards.reduce((closestIndex, card, index) => {
          const currentDistance = Math.abs(cards[closestIndex].offsetLeft - track.scrollLeft);
          const nextDistance = Math.abs(card.offsetLeft - track.scrollLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);

        if (count) count.textContent = `${activeIndex + 1} / ${cards.length}`;
        if (prev) prev.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === cards.length - 1;
        dots.forEach((dot, index) => {
          const current = index === activeIndex;
          dot.classList.toggle('is-active', current);
          if (current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        cards.forEach((card, index) => {
          if (index !== activeIndex) pauseVideo(card.querySelector('video[data-nh-video]'));
        });
      };

      const scrollToIndex = (index) => {
        const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
        cards.forEach((card) => pauseVideo(card.querySelector('video[data-nh-video]')));
        track.scrollTo({ left: targetIndex * cardStep(), behavior: 'smooth' });
      };

      root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-nh-video-toggle]');
        if (toggle && root.contains(toggle)) {
          event.preventDefault();
          event.stopPropagation();
          toggleVideo(toggle.closest('[data-nh-video-card]')?.querySelector('video[data-nh-video]'));
          return;
        }

        const video = event.target.closest('video[data-nh-video]');
        if (video && root.contains(video)) toggleVideo(video);
      });

      root.addEventListener('keydown', (event) => {
        const video = event.target.closest('video[data-nh-video]');
        if (!video || !root.contains(video) || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        toggleVideo(video);
      });

      cards.forEach((card) => {
        const video = card.querySelector('video[data-nh-video]');
        if (!video) return;
        video.tabIndex = 0;
        video.addEventListener('play', () => syncCard(video));
        video.addEventListener('pause', () => syncCard(video));
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          syncCard(video);
        });
      });

      prev?.addEventListener('click', () => scrollToIndex(activeIndex - 1));
      next?.addEventListener('click', () => scrollToIndex(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToIndex(index)));

      track.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateNavigation);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(updateNavigation);
        });
        resizeObserver.observe(track);
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) cards.forEach((card) => pauseVideo(card.querySelector('video[data-nh-video]')));
          });
        }, { threshold: 0.15 });
        observer.observe(root);
      }

      updateNavigation();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll(`${rootSelector} video[data-nh-video]`).forEach(pauseVideo);
  });
})();
